module.exports = __webpack_public_path__ + "static/media/didiao004.dd859f87.jpg";